import PositionIndicator from './PositionIndicator';

export default PositionIndicator;
